import React, {
 useMemo,
 useEffect,
 ChangeEvent,
 useState,
} from 'react'
import debouce from 'lodash.debounce'
import {KTSVG} from './KTSVG'

type Props = {
 isDisabled?: boolean
 label?: string
 labelClass?: string
 iconClass?: string
 wrapperClass?: string
 iconPath?: string
 placeholder?: string
 setSearchTerm: (searchText: string) => void
}
const KTSearchBox = ({
 isDisabled,
 wrapperClass,
 labelClass,
 iconClass,
 label,
 iconPath,
 placeholder,
 setSearchTerm,
}: Props) => {
 const [searchText, setSearchText] = useState('')
 const handleChange = (
  e: ChangeEvent<HTMLInputElement>
 ) => {
  const value = e?.target.value
  setSearchText(value)
  if (value.length >= 3 || value.length === 0) {
   setSearchTerm(value ?? '')
  }
 }

 const debouncedResults = useMemo(() => {
  return debouce(handleChange, 300)
 }, [])

 useEffect(() => {
  return () => {
   debouncedResults.cancel()
  }
 })

 return (
  <div
   className={`${wrapperClass} flex rounded-lg border border-[#CED8E0] px-3 py-2 items-center`}
  >
   <KTSVG
    path={`${iconPath ?? '/media/icons/search.svg'}`}
    svgClassName={`${iconClass} w-6 h-6`}
   />
   {searchText.length === 0 && (
    <span
     className={`${labelClass} text-[#33393D] text-base`}
    >
     {label}
    </span>
   )}
   <input
    disabled={isDisabled}
    type='text'
    className='w-full text-[#33393D] text-base !py-1 !px-1 !outline-0 !rounded-none'
    placeholder={placeholder}
    onChange={debouncedResults}
   />
  </div>
 )
}

export {KTSearchBox}
